import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import vuetify from "./plugins/vuetify";

import VueSweetalert2 from "vue-sweetalert2";
import VueThailandAddress from "vue-thailand-address";
import DatePicker from "vue2-datepicker";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

import "@/assets/main.css";
import "vue2-datepicker/locale/th";
import "vue2-datepicker/index.css";
import "vue-thailand-address/dist/vue-thailand-address.css";
import * as VueGoogleMaps from 'vue2-google-maps'
//Vue.config.productionTip = false;
import axios from 'axios';
const payment_token = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiTmV3Y2hva3VtbnVhaSIsImRhdGUiOjIwMDEyNTY0fQ.i5tdbVY42SR07i-xZcajuPUWEn9p9-T3K7_r5vDkycw`

// const api_url = 'http://localhost:4000/municipality/api/v1'
// const api_url_photos = 'http://163.44.196.235/municipality/api/v1/app'
// const web_url = 'http://localhost:8080'
// const payment_url = `https://ipstthailand.com:31001/newchokumnuai/uat`

// const api_url = 'https://manifest-newchoke.com/newchoke/api/v1'
// const api_url_photos = 'https://manifest-newchoke.com/newchoke/api/v1/app'
// const web_url = 'https://manifest-newchoke.com'
// const payment_url = `https://ipstthailand.com:41001/newchokumnuai` 

const api_url = 'https://mct.cool-agri.com/municipality/api/v1'
const api_url_photos = 'https://mct.cool-agri.com/municipality/api/v1/app'
const web_url = 'https://mct.cool-agri.com'
const payment_url = `https://ipstthailand.com:31001/newchokumnuai/uat`

Vue.config.productionTip = false
Vue.use(DatePicker);
Vue.use(VueSweetalert2);
Vue.use(VueThailandAddress);
Vue.use(VueMoment, {
  moment
});


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCILH3Jm2VQBzN19Sx64uX-1nFYbvtxr6E',
    libraries: 'places',
    v: 3.38
  }
})

Vue.use({
  install(Vue) {
    Vue.prototype.$payment_api = axios.create({
      baseURL: payment_url,
      timeout: 30000,
      headers: {
        "Authorization": payment_token
      },
    })
    Vue.prototype.$guest_api = axios.create({
      baseURL: api_url,
      timeout: 30000,
      headers: {
        "content-type": "application/json"
      },
    })
    Vue.prototype.$token_api = axios.create({
      baseURL: api_url,
      timeout: 30000,
      headers: {
        "Authorization": localStorage.getItem("jwt")
      },
    })
    Vue.prototype.$download_api = axios.create({
        baseURL: api_url,
        timeout: 30000,
        headers: {
          "Authorization": localStorage.getItem("jwt")
        },
        responseType: 'blob'

      }),
      Vue.prototype.$file_api = axios.create({
        baseURL: api_url,
        timeout: 30000,
        headers: {
          "Content-Type": "multipart/form-data"
        },
      }),
      Vue.prototype.$img_url_O = api_url_photos + '/signature',
      Vue.prototype.$img_url_R = api_url_photos + '/trasac_des_sig_pic',
      Vue.prototype.$global_link = web_url

    Vue.prototype.$AppName = {
      // name: 'นิวโชคอำนวยเชียงใหม่',
      // company: 'บริษัท นิวโชคอำนวยเชียงใหม่',
      // limited_company: 'บริษัท นิวโชคอำนวยเชียงใหม่ จำกัด',
      // partnership: 'หจก.นิวโชคอำนวย (เชียงใหม่)',
      // CoLtd: 'บจก.นิวโชคอำนวย (เชียงใหม่)',
      // CoLtdMenuBar: 'บจก.นิวโชคอำนวย',
      // CoLtdMenuBarFull: 'บจก.นิวโชคอำนวยเชียงใหม่',
      // Logo: 'newchok-icon.png',
      // color: 'light-red darken-2',
      // LogoPath: 'https://manifest-newchoke.com/newchoke/api/v1/app/signature/newchok-icon.png',
      // SignaturePath: 'https://manifest-newchoke.com/newchoke/api/v1/app/signature/signature.jpg',

      name: 'เทศบาลนครเชียงใหม่',
      company: 'เทศบาลนครเชียงใหม่',
      limited_company: 'เทศบาลนครเชียงใหม่',
      partnership: 'เทศบาลนครเชียงใหม่',
      CoLtd: 'เทศบาลนครเชียงใหม่', 
      CoLtdMenuBar: 'เทศบาลนครเชียงใหม่', 
      CoLtdMenuBarFull: 'เทศบาลนครเชียงใหม่',
      Logo:'municipalitylogo.png',
      color:'light-orange darken-2',
      LogoPath: 'https://mct.cool-agri.com/municipality/api/v1/app/signature/municipalitylogo.png',
      SignaturePath: 'https://mct.cool-agri.com/municipality/api/v1/app/signature/signature.jpg',
    }
  }
});



new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");